import React from "react";

const Privacy = () => {
  return (
    <div id="account-menu-container" className="terms responsive-page">
      <p className="title">
        <strong>NYA PRIVACY POLICY</strong>
      </p>
      <p>
        <strong>LAST UPDATED November 26, 2018</strong>
      </p>
      <p>
        For the full Privacy Policy, please visit{" "}
        <a href="/privacy.html" target="_blank" rel="noopener noreferrer">
          this page
        </a>.
      </p>
    </div>
  );
};

export default Privacy;
